import { lastValueFrom, Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as config } from '../../../../environments/environment';
import { GoalSettings, UsedGoal } from '../models/goals';
import { Params } from '@angular/router';
import { StatusRequest, ChangeOrderRequest } from '../../shared/models/models';
import { VisitorInfo } from '../../shared/models/tracking.models';


@Injectable({
  providedIn: 'root'
})
export class GoalsService {
  private http = inject(HttpClient);

  getGoals(filters: Params): Observable<{ total: number; data: GoalSettings[] }> {
    return this.http.get<{ total: number; data: GoalSettings[] }>(`${config.adminBaseUrl}/api/goals`, { params: filters });
  }

  getSingleGoal(goalId: number): Observable<GoalSettings> {
    return this.http.get<GoalSettings>(`${config.adminBaseUrl}/api/goals/${goalId}`);
  }

  getUsedGoals(): Promise<UsedGoal[]> {
    return lastValueFrom(this.http.get<UsedGoal[]>(`${config.adminBaseUrl}/api/goals/used`));
  }

  public async addGoal(request: GoalSettings): Promise<number> {
    return lastValueFrom(this.http.post<number>(`${config.adminBaseUrl}/api/goals`, request));
  }

  public async updateGoal(goalId: number, request: GoalSettings): Promise<void> {
    return await lastValueFrom(this.http.patch<void>(`${config.adminBaseUrl}/api/goals/${goalId}`, request));
  }

  public async changeGoalStatus(goalId: number, request: StatusRequest): Promise<void> {
    await lastValueFrom(this.http.patch<void>(`${config.adminBaseUrl}/api/goals/${goalId}/change_status`, request));
  }

  public async changeGoalsOrder(request: ChangeOrderRequest): Promise<void> {
    await lastValueFrom(this.http.patch<void>(`${config.adminBaseUrl}/api/goals/change_order`, request));
  }

  getVisitorInfo(accountId: number, email: string): Observable<VisitorInfo> {
    const params = {
      email
    };
    return this.http.get<VisitorInfo>(`${config.adminBaseUrl}/api/goals/visitor-by-email`, { headers: { skip: 'true' }, params });
  }

}
